exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-ee17a6f4],\n.fade-leave-active[data-v-ee17a6f4] {\n    transition: opacity 0.5s;\n}\n.fade-enter[data-v-ee17a6f4], .fade-leave-to[data-v-ee17a6f4] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\n.error[data-v-ee17a6f4] {\n    color: rgba(255, 0, 0, 0.6) !important;\n}\n.error-ctrl[data-v-ee17a6f4] {\n    background-color: rgba(255, 0, 0, 0.16) !important;\n}\n", ""]);

// exports
